import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ThemeDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-theme',
  templateUrl: './theme.component.html',
  styleUrls: ['./theme.component.css']
})
export class ThemeComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.themes$) themes$: Observable<ThemeDto[]>;
  
  @Input('themeId') public themeId: number;

  ThemeInComponent: ThemeDto;

  p: Subscription;

  constructor() { }

  ngOnInit() {
    this.p = this.themes$.subscribe(res => {
      if (res != null) {
        let theme = res.filter(p => p.Id == this.themeId);
        this.ThemeInComponent = theme.length == 1 ? theme[0] : { Nom: null };
      }
    });
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }

}
